import React, { useState, useEffect } from "react"
import { configData } from "../config/systemconfigurationconstants";
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import lambdaConfig from '../hooks/lambdaConfig';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const DgGeneralInfoPublishCompleteLoan = ({ glassboxjson, LoanStatus }) => {
    const [dotloader, setDotLoader] = useState(true);
    const [showpublish, setShowpublish] = useState(false);
    const handleClose = () => setShowpublish(false);
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const navigate = useNavigate();
    const publishLoan = async () => {
        handleClose();

        try {
            setDotLoader(false)

            const parsedBody = await invokeLambda(configData.PUBLISH_RESULTS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                "LoanGuid": localStorage.getItem('loanGuid'),
                "ClientShortName": localStorage.getItem('ClientShortName'),
                "UseCaseShortName": localStorage.getItem('UseCaseShortName')
            });
            if (parsedBody.Status) {
                toast.success("Loan Published Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 2500);
                setTimeout(() => {
                    navigate('/dashboard')
                }, 3000);
            } else {
                toast.error("Loan Publish Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 2500);
                setTimeout(() => {
                    navigate('/dashboard')
                }, 3000);
            }

        } catch (err) {
            // Handle error if needed
        }
    }
    const completeLoan = async () => {
        handleClose();
        try {
            setDotLoader(false)

            const parsedBody = await invokeLambda(configData.COMPLETE_LOAN, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                "LoanGuid": localStorage.getItem('loanGuid'),
                "ClientShortName": localStorage.getItem('ClientShortName'),
                "UseCaseShortName": localStorage.getItem('UseCaseShortName')
            });
            if (parsedBody.Status) {
                toast.success("Loan Completed Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 2500);
                setTimeout(() => {
                    navigate('/dashboard')
                }, 3000);
            } else {
                toast.error("Loan Completed Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 2500);
                setTimeout(() => {
                    navigate('/dashboard')
                }, 3000);
            }

        } catch (err) {
            // Handle error if needed
        }
    }
    const showpopup = () => {
        setShowpublish(true);
    }

    const hasRightsToPublish = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "PUBLISH")?.RightId;
            if (userRights.some(el => el.RightId == rightID)) {
                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    const hasRightsToCompleteLoan = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "COMPLETE_LOAN")?.RightId;
            if (userRights.some(el => el.RightId == rightID)) {
                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }


    return (<>
        {dotloader ? (
            LoanStatus !== "Completed" && (
                <div className="d-flex justify-content-end mb-2">
                    {LoanStatus === "Published" ? (
                        <>
                            {hasRightsToCompleteLoan() && (<button
                                type="button"
                                className="btn btn-primary btn-sm me-5"
                                onClick={showpopup}
                            >
                                Complete Loan
                            </button>)}
                        </>
                    ) : (
                        <>
                            {hasRightsToPublish() && (<button
                                type="button"
                                className="btn btn-primary btn-sm me-5"
                                onClick={showpopup}
                            >
                                Publish
                            </button>)}
                        </>
                    )}
                </div>
            )
        ) : (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // semi-transparent white
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}
                className="d-flex justify-content-center"
            >
                <div className="loader"></div>
            </div>
        )}
        <Modal show={showpublish} onHide={handleClose}>
            <Modal.Header closeButton>
                {LoanStatus === "Published" ? <Modal.Title>Complete Loan</Modal.Title> : <Modal.Title>Publish Loan</Modal.Title>}
            </Modal.Header>
            {LoanStatus === "Published" ? <Modal.Body>Are You Sure, You want to Complete Loan?</Modal.Body> : <Modal.Body>Are You Sure, You want to Publish Loan?</Modal.Body>}
            <Modal.Footer>
                <button type="button" class="btn btn-primary btn-sm" onClick={handleClose}>Close</button>
                {/* <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button> */}
                {/* <Button variant="primary" onClick={handleClose}>
                    Save Changes
                  </Button> */}
                {LoanStatus === "Published" ? <button type="button" class="btn btn-primary btn-sm" onClick={completeLoan}>Complete Loan</button> : <button type="button" class="btn btn-primary btn-sm" onClick={publishLoan}>Publish</button>}
            </Modal.Footer>
        </Modal>
    </>)
}
export default DgGeneralInfoPublishCompleteLoan